import React from 'react';
import LocationTemplate from './LocationTemplate';

const KenlyPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Kenly"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27542"]}
      latitude={35.5937}
      longitude={-78.1239}
      population={1569}
      historicalFact="Originally called Cottondale, renamed for John R. Kenly, a Union officer from Maryland."
      nearbyTowns={[
        "Wilson, NC",
        "Selma, NC",
        "Four Oaks, NC",
        "Lucama, NC",
        "Princeton, NC",
        "Pine Level, NC",
        "Micro, NC",
        "Elm City, NC"
      ]}
    />
  );
};

export default KenlyPage;